import { render } from "./UpdateNew.vue?vue&type=template&id=8dbce4ec&scoped=true"
import script from "./UpdateNew.vue?vue&type=script&lang=js"
export * from "./UpdateNew.vue?vue&type=script&lang=js"

import "./UpdateNew.vue?vue&type=style&index=0&id=8dbce4ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8dbce4ec"]])

export default __exports__